/** API 기본 URL */
export const API_BASE_URL = '/api/v1'

/** 앱 이름 */
export const APP_NAME = 'CareBalance'

/** 앱 설명 */
export const APP_DESCRIPTION = '부모님 요양시설, 함께 찾아드려요'

/** 로컬 스토리지 키 */
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'cb_access_token',
  REFRESH_TOKEN: 'cb_refresh_token',
  USER: 'cb_user',
} as const

/** API 에러 메시지 */
export const ERROR_MESSAGES = {
  NETWORK_ERROR: '네트워크 연결을 확인해주세요.',
  SERVER_ERROR: '서버에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
  UNAUTHORIZED: '로그인이 필요합니다.',
  FORBIDDEN: '접근 권한이 없습니다.',
  NOT_FOUND: '요청한 정보를 찾을 수 없습니다.',
  VALIDATION_ERROR: '입력 정보를 확인해주세요.',
  TOKEN_EXPIRED: '세션이 만료되었습니다. 다시 로그인해주세요.',
  UNKNOWN_ERROR: '알 수 없는 오류가 발생했습니다.',
} as const

/** 라우트 경로 */
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FACILITIES: '/facilities',
  FACILITY_DETAIL: '/facilities/:id',
  COST_SIMULATOR: '/cost-simulator',
  RECOMMEND: '/recommend',
  RECOMMEND_RESULT: '/recommend/result',
  BOOKMARKS: '/bookmarks',
  COMPARE: '/compare',
  MYPAGE: '/mypage',
  MYPAGE_EDIT: '/mypage/edit',
  MYPAGE_PARENT_INFO: '/mypage/parent-info',
  CARE_LOG: '/mypage/care-log',
  CARE_LOG_SUBJECT_NEW: '/mypage/care-log/subject/new',
  CARE_LOG_NEW: '/mypage/care-log/new',
  GUIDE_RESOURCES: '/guide/resources',
  SELF_ASSESSMENT: '/guide/self-assessment',
  SELF_ASSESSMENT_RESULT: '/guide/self-assessment/result',
  CHECKLIST: '/checklist',
  CHECKLIST_RESULT: '/checklist/result',
} as const

/** 하단 네비게이션 탭 */
export const BOTTOM_NAV_TABS = [
  { label: '홈', path: ROUTES.HOME, icon: 'Home' },
  { label: '검색', path: ROUTES.FACILITIES, icon: 'Search' },
  { label: '돌봄일지', path: ROUTES.CARE_LOG, icon: 'HeartHandshake' },
  { label: '마이', path: ROUTES.MYPAGE, icon: 'User' },
] as const
